import authAxios from "../utils/authAxios";

const cardClient = {
    /**
     * Формат и методику этот запрос больше не принимает: счётчики верных и неверных
     * лежат на слове, а не на паре «формат и слово», и от того, каким форматом открыта
     * колода, не зависят.
     */
    getCardsByDeckId: async (deckId, { page = 0, size = 10 } = {}) => {
        const params = new URLSearchParams({ page, size });
        return await authAxios(`/api/card-info/deck/${deckId}?${params}`, {
            method: 'GET',
        });
    },

    getCardById: async (cardId) => {
        return await authAxios(`/api/cards/${cardId}`, {
            method: 'GET',
        });
    },

    createCard: async (card) => {
        return await authAxios(`/api/cards`, {
            method: 'POST',
            data: card,
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },

    updateCard: async (cardId, card) => {
        return await authAxios(`/api/cards/${cardId}`, {
            method: 'PUT',
            data: card,
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },

    deleteCard: async (cardId) => {
        return await authAxios(`/api/cards/${cardId}`, {
            method: 'DELETE',
        });
    },
};

export default cardClient;
